// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { AppGuardService } from '@coa/app/core/services/app-guard.service';
import { HomeGuardService } from './guards/home-guard.service';
import { SidenavDecoratorComponent } from './components/sidenav-decorator/sidenav-decorator.component';
import { HomeContentDecoratorComponent } from '@coa/app/home/components/home-content-decorator/home-content-decorator.component';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';
import { FeatureToggleGuard } from '@coa/app/shared/feature-toggle/guards/feature-toggle.guard';

const routes: Routes = [
  {
    path: 'clients/:clientId',
    component: HomeComponent,
    canActivate: [AppGuardService, HomeGuardService],
    children: [
      {
        path: '',
        component: SidenavDecoratorComponent,
        children: [
          {
            path: '',
            component: HomeContentDecoratorComponent,
            children: [
              {
                path: 'dashboard',
                loadChildren: (): Promise<any> => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
              },
              {
                path: 'stores',
                children: [
                  {
                    path: '',
                    loadChildren: (): Promise<any> => import('./modules/stores/stores.module').then(m => m.StoresModule),
                  },
                  {
                    path: ':storeId',
                    loadChildren: (): Promise<any> => import('./modules/store-details/store-details.module').then(m => m.StoreDetailsModule),
                  },
                ],
              },
              {
                path: 'groups',
                canActivate: [FeatureToggleGuard],
                data: {featureToggle: FeatureToggle.DYNAMIC_GROUPS_ENABLED},
                children: [
                  {
                    path: '',
                    loadChildren: (): Promise<any> => import('./modules/groups/groups.module').then(m => m.GroupsModule),
                  },
                  {
                    path: ':groupId',
                    loadChildren: (): Promise<any> => import('./modules/group-details/group-details.module').then(m => m.GroupDetailsModule),
                  },
                ],
              },
              {
                path: 'floors',
                canActivate: [FeatureToggleGuard],
                data: {featureToggle: FeatureToggle.FLOORS_VIEW_ENABLED},
                children: [
                  {
                    path: '',
                    loadChildren: (): Promise<any> => import('./modules/floors/floors.module').then(m => m.FloorsModule),
                  },
                  {
                    path: ':floorId',
                    loadChildren: (): Promise<any> => import('./modules/floor-details/floor-details.module').then(m => m.FloorDetailsModule),
                  },
                ],
              },
              {
                path: 'compare',
                children: [
                  {
                    path: '',
                    loadChildren: (): Promise<any> => import('./modules/compare/compare.module').then(m => m.CompareModule),
                  },
                  {
                    path: ':selectableFeature',
                    loadChildren: (): Promise<any> => import('./modules/compare-feature/compare-feature.module').then(m => m.CompareFeatureModule),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'clients/:clientId/groups',
    canActivate: [AppGuardService, HomeGuardService, FeatureToggleGuard],
    data: {featureToggle: FeatureToggle.DYNAMIC_GROUPS_ENABLED},
    children: [
      {
        path: ':groupId/edit',
        loadChildren: (): Promise<any> => import('./modules/group-edit/group-edit.module').then(m => m.GroupEditModule),
      },
    ],
  },
  {
    path: 'invitations',
    loadChildren: (): Promise<any> => import('./modules/client-user-invitation/client-user-invitation.module').then(m => m.ClientUserInvitationModule),
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AppGuardService, HomeGuardService],
    children: [
      {
        path: 'select-client',
        loadChildren: (): Promise<any> => import('./modules/select-client/select-client.module').then(m => m.SelectClientModule),
      },
      {
        path: 'unauthorized',
        loadChildren: (): Promise<any> => import('./modules/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
      },
      {
        path: 'manage-clients',
        loadChildren: (): Promise<any> => import('./modules/manage-clients/manage-clients.module').then(m => m.ManageClientsModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {
}
